export default __webpack_public_path__ + "upload-purple-icon.png";